import { useCallback } from 'react';
import { api } from 'src/constants/apiRoutes';
import useAsync from 'src/hooks/useAsync';
import axiosInstance from 'src/utils/axios';

interface CancelPORequest {
  poIds?: any[];
}

const useCancelPoApi = () => {
  const call = useCallback(async ({ poIds }: CancelPORequest = {}) => {
    try {
      const res = await axiosInstance.post(api.cancelPO, poIds);
      return res;
    } catch (error) {
      throw new Error(error);
    }
  }, []);

  const { isLoading, execute } = useAsync(call, false);

  return { cancelPo: execute, cancelPoCallLoading: isLoading };
};

export default useCancelPoApi;
